"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildColonyStandardProject = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const StandardProjectCard_1 = require("../StandardProjectCard");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const ColonyName_1 = require("../../colonies/ColonyName");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const Card_1 = require("../Card");
class BuildColonyStandardProject extends StandardProjectCard_1.StandardProjectCard {
    constructor() {
        super({
            name: CardName_1.CardName.BUILD_COLONY_STANDARD_PROJECT,
            cost: 17,
            metadata: {
                cardNumber: 'SP5',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.standardProject('Spend 17 M€ to place a colony.', (eb) => {
                    eb.megacredits(17).startAction.colonies();
                })),
            },
        });
    }
    getOpenColonies(player) {
        let openColonies = player.game.colonies.filter((colony) => colony.isActive && colony.colonies.includes(player.id) === false);
        if (player.game.gameOptions.equalOpportunityVariant === false) {
            openColonies = openColonies.filter((colony) => colony.colonies.length < 3);
        }
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (redsAreRuling) {
            const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.NAOMI) ? 3 : 0;
            const canAffordToBuildOnEuropaColony = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ card: this, oceansToPlace: 1, bonusMegaCredits: bonusMegaCredits }));
            if (canAffordToBuildOnEuropaColony.canAfford === false)
                openColonies = openColonies.filter((c) => c.name !== ColonyName_1.ColonyName.EUROPA);
            const canAffordToBuildOnVenusColony = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ card: this, venusIncrease: 1, bonusMegaCredits: bonusMegaCredits }));
            if (canAffordToBuildOnVenusColony.canAfford === false)
                openColonies = openColonies.filter((c) => c.name !== ColonyName_1.ColonyName.VENUS);
            const canAffordToBuildOnIapetusColony = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ card: this, TRIncrease: 1, bonusMegaCredits: bonusMegaCredits }));
            if (canAffordToBuildOnIapetusColony.canAfford === false)
                openColonies = openColonies.filter((c) => c.name !== ColonyName_1.ColonyName.IAPETUS);
        }
        return openColonies;
    }
    canAct(player) {
        const availableColonies = this.getOpenColonies(player);
        const colonyNames = availableColonies.map((c) => c.name);
        const hasEuropa = colonyNames.includes(ColonyName_1.ColonyName.EUROPA) && player.game.canAddOcean();
        const hasVenus = colonyNames.includes(ColonyName_1.ColonyName.VENUS) && player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE;
        const hasIapetus = colonyNames.includes(ColonyName_1.ColonyName.IAPETUS);
        if (hasEuropa || hasVenus || hasIapetus) {
            const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
            Card_1.Card.setRedsActionWarningText(player, 1, this, redsAreRuling, 'build a colony', true);
        }
        return super.canAct(player) && availableColonies.length > 0;
    }
    actionEssence(player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony'));
    }
}
exports.BuildColonyStandardProject = BuildColonyStandardProject;
//# sourceMappingURL=BuildColonyStandardProject.js.map